import * as React from 'react';
import './index.less';
// import 'antd/dist/antd.css';
import {ActiveTableProps} from './index.d'
import MainView from "./pages/mainView";
import ActiveField from "./components/ActiveField";
import OpreateTable from "./pages/OpreateTable"
import GComponents from "./components/GComponent";
import GInput from "./components/GInput";
import GRefTable from "./components/GRefTable";
import GSearch from "./components/GSearch";
import GTableList from "./components/GTableList";
import GTable from "./components/GTable";
import TableSelect from "./components/TableSelect";
import GModelForm from "./components/GModelForm";
import {MyContext} from './utils/contextManage';
import GTableWithReferenceRule from "./components/GTableWithReferenceRule";

const ActiveTable: React.FC<ActiveTableProps> = (props) => {
  return (<MainView {...props}/>);
}
export {
  OpreateTable,
  ActiveField,
  GComponents,
  GInput,
  GRefTable,
  GSearch,
  GTableList,
  GTable,
  TableSelect,
  GModelForm,
  MyContext,
  GTableWithReferenceRule
}
export default ActiveTable;